import styled, {css} from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {Button} from '@components/ui/button/Button.tsx'

export const MeasureRawWrapper = styled.div`
    ${({theme: {palette}}) => css`
        display: flex;
        flex-direction: column;
        height: 100vh;
        width: 100vw;
        background: ${palette.neutral.white};
        overflow: hidden;
    `}
`

export const MeasureRawTopbar = styled(Flexbox)`
    ${({theme: {palette, spacing, mediaQueries}}) => css`
        box-sizing: border-box;
        background: ${palette.neutral.white};
        border-bottom: 1px solid ${palette.neutral['200']};
        padding: ${spacing * 4.5}px ${spacing * 8}px;
        display: grid;
        grid-template-columns: auto auto;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;

        ${mediaQueries.m} {
            padding: ${spacing * 3}px ${spacing * 4}px;
        }
    `}
`

export const MeasureRawTopbarTitle = styled.h5`
    ${({theme: {palette, typography, spacing}}) => css`
        ${typography.textXl};
        font-weight: 600;
        color: ${palette.neutral['800']};
        padding: ${spacing * 2}px 0;
        cursor: pointer;
    `}
`

export const MeasureRawContent = styled.div`
    flex: 1;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
`

export const MeasureRawIframe = styled.iframe`
    width: 100%;
    height: 100%;
    border: none;
    display: block;
`

export const StyledIconButton = styled(Button)`
    ${() => css`
        border-radius: 12px;
    `}
`
